const fiftyFiftyCardCarousel = (): void => {
  // console.log('50/50 Card Carousel');
};

export default fiftyFiftyCardCarousel;
